// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2KIRf","amount":"Amount_amount__4ZWHi","tip":"Amount_tip__cYLbx","tipHeader":"Amount_tipHeader__1wNYW","tipsWrap":"Amount_tipsWrap__gU_Ok"};